import Vue from 'vue'
import components from '../components'

components.forEach(component => {
  Vue.component(component.name, component)
})



// WEBPACK FOOTER //
// ./src/pages/index.js